// Data seam for the private investments — venture positions and DAO
// memberships, kept by hand. Mirrors src/data/crypto.js.

import { request } from './portfolio';

/** Resolves to `{ investments }`, every investment with its rounds. */
export const getPrivate = () => request('private');

export const createInvestment = (investment) =>
  request('private', { method: 'POST', body: JSON.stringify(investment) });

/** Replaces the investment's fields and its whole set of rounds. */
export const updateInvestment = (id, investment) =>
  request(`private/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(investment) });

/** Active to exited, or back. */
export const moveInvestment = (id, status) =>
  request(`private/${encodeURIComponent(id)}/status`, {
    method: 'PUT',
    body: JSON.stringify({ status }),
  });

export const deleteInvestment = (id) =>
  request(`private/${encodeURIComponent(id)}`, { method: 'DELETE' });
